document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.season-hero').forEach((hero) => {

    const video = hero.querySelector('.season-hero__main-video');
    const button = hero.querySelector('.season-hero__sound-button');

    if (!video || !button) return;

    // 自動再生を試みる
    video.play().catch(() => {});

    button.addEventListener('click', () => {

      video.muted = !video.muted;

      if (video.muted) {

        button.textContent = 'Sound OFF';
        button.setAttribute('aria-label', '音声をオンにする');

      } else {

        button.textContent = 'Sound ON';
        button.setAttribute('aria-label', '音声をオフにする');

      }

    });

  });

});